import React from 'react';
import PropTypes from 'prop-types';
import styles from 'components/CategoryList/CategoryList.scss';
import history from 'dashboard/history';
import { SpecialClasses } from 'lib/Constants';

import Tooltip from 'rc-tooltip';

export default class CategoryList extends React.Component {
  constructor() {
    super();

    this.state = {
      links: null,
    };
  }

  componentDidMount() {
    const { categories } = this.props;

    if (categories) {
      this.setState({
        links: categories,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ links: nextProps.categories });
  }

  handleClick(link, e) {
    history.push(link);
    e.preventDefault();
    e.stopPropagation();
  }

  linksRender() {
    const arr = this.state.links;
    if (!arr) {
      return null;
    }

    const links = [];

    for (let i = 0; i < arr.length; i++) {
      const id = arr[i].id || arr[i].name;
      const className = id === this.props.current ? styles.active : '';
      const link = this.context.generatePath((this.props.linkPrefix || '') + (arr[i].link || id));

      const linkElement = (
        <a href={link} onClick={this.handleClick.bind(this, link)} className={className} key={id + new Date()}>
          { SpecialClasses[id] ? <span className={styles.PredefinedClass} /> : null }
          <span>{arr[i].name}</span>
          <span>{arr[i].count}</span>
        </a>
      );

      links.push(SpecialClasses[id]
        ?
          <Tooltip key={id + new Date()} placement="right" overlay="Predefined Class" arrowContent={<div className="rc-tooltip-arrow-inner" />}>
            {linkElement}
          </Tooltip>
        : linkElement);
    }

    return links;
  }

  render() {
    if (this.props.categories.length === 0) {
      return null;
    }

    const elements = this.linksRender();

    if (!elements) {
      return null;
    }

    return (
      <div className={styles.class_list}>
        {elements}
      </div>
    );
  }
}

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  current: PropTypes.string,
  linkPrefix: PropTypes.string,
};

CategoryList.contextTypes = {
  generatePath: PropTypes.func,
};
